import React, { createContext, useContext, useState, ReactNode } from 'react'

interface MenuContextType {
  showMenu: boolean
  setShowMenu: (show: boolean) => void
  toggleMenu: () => void
}

const MenuContext = createContext<MenuContextType | undefined>(undefined)

export const useMenuContext = () => {
  const context = useContext(MenuContext)
  if (context === undefined) {
    throw new Error('useMenuContext must be used within a MenuProvider')
  }
  return context
}

interface MenuProviderProps {
  children: ReactNode
}

export const MenuProvider: React.FC<MenuProviderProps> = ({ children }) => {
  const [showMenu, setShowMenu] = useState(false)

  const toggleMenu = () => {
    setShowMenu(!showMenu)
  }

  const value = {
    showMenu,
    setShowMenu,
    toggleMenu,
  }

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>
}
